import { z } from 'zod';

const FaqQuestionSchema = z.object({
  id: z.string(),
  title: z.string(),
  answer: z.any(),
});

const FaqCategorySchema = z.object({
  id: z.string(),
  title: z.string(),
  questions: z.array(FaqQuestionSchema),
});

export const FaqsSchema = z.array(FaqCategorySchema);

export type Faqs = z.infer<typeof FaqsSchema>;

export interface FaqsService {
  loadFaqs: () => Promise<Faqs>;
}
